import { render } from "./NewSupplier.vue?vue&type=template&id=7895359a&scoped=true"
import script from "./NewSupplier.vue?vue&type=script&lang=js"
export * from "./NewSupplier.vue?vue&type=script&lang=js"

import "./NewSupplier.vue?vue&type=style&index=0&id=7895359a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7895359a"]])

export default __exports__